import { createQueryParams, readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import TabItem from '@navi/web-ui/lib/components/Tabs/TabItem';
import Tabs from '@navi/web-ui/lib/components/Tabs/Tabs';
import cx from 'classnames';
import { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CONTACT_TABS_KEYS, UI_ELEMENT, defaultQueryParams } from '../../constants';
import styles from './index.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { createKey } from '@cp/src/utils/CaseDetail.utils';

const Contact = () => {
  const navigate = useNavigate();
  const allQueryParams = readQueryParams();
  const { [UI_ELEMENT]: queryParams, callAudit } = allQueryParams;

  const updateAndNavigate = (params: Record<string, unknown>) => {
    // Preserve callAudit params when navigating
    const paramsWithAudit = callAudit ? { ...params, callAudit } : params;
    const url = createQueryParams(paramsWithAudit);
    navigate(url, { replace: true });
  };

  useEffect(() => {
    if (!queryParams?.selectedTab) {
      updateAndNavigate(defaultQueryParams);
    }
  }, []);

  const handleTabChange = useCallback(
    (selectedSubTab: string) => {
      const updatedParams = {
        [UI_ELEMENT]: {
          selectedTab: selectedSubTab
        }
      };
      updateAndNavigate(updatedParams);
    },
    [callAudit]
  );

  const { loanId = '', customerId = '' } = useParams();

  const isPaused = useSelector(
    (state: RootState) =>
      state.caseDetail.pageData?.[createKey(loanId, customerId)]?.pause?.data?.isPaused
  );

  return (
    <div
      className={cx(styles.tabContainer, styles.tabContentScroll, {
        [styles.tableContentScrollWithPausedCase]: isPaused
      })}
    >
      <Tabs
        selectedTabKey={queryParams?.selectedTab}
        tabsClassName={styles.tabClass}
        orientation="vertical"
        variant="pill"
        onTabChange={e => handleTabChange(e as string)}
        contentClassName={styles.tabContent}
        containerClassName={styles.containerClass}
        defaultSelectedKey={queryParams?.selectedTab}
      >
        {CONTACT_TABS_KEYS.map(tab => (
          <TabItem key={tab.key} label={tab.value}>
            {tab.component}
          </TabItem>
        ))}
      </Tabs>
    </div>
  );
};

export default Contact;
